import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class DpeAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/dpes";
    return this.CommonAPIService.getCall(url, null, router);
  }

  getById(id, router) {
    const url = `/api/dpes/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = "/api/dpes";
    return this.CommonAPIService.postCall(url, params, router);
  }
  delete(id, router) {
    const url = `/api/dpes/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(id, params, router) {
    const url = `/api/dpes/${id}`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  getPreferredOptions(router) {
    const url = "/api/dpes/preferredOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getPreferredMethodOptions(router) {
    const url = "/api/dpes/preferredMethodOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getTravelOptions(router) {
    const url = "/api/dpes/travelOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }
}
export default DpeAPIService;
